import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import * as getTestCredentials from '../../redux/healthboard/requests/network-test-credentials-req';
import { loggedUserIdSelector } from '../../redux/context/selectors';
import {
  selectNetworkTestCredentialsPending,
  selectNetworkTestCredentials,
} from '../../redux/healthboard/selectors';
import { selectVisitTestCallPerformed } from '../../redux/data/selectors';

const mapStateToProps = state => ({
  loggedUserId: loggedUserIdSelector(state),
  pending: selectNetworkTestCredentialsPending(state),
  testCredentials: selectNetworkTestCredentials(state),
  visitTestPerformed: selectVisitTestCallPerformed(state),
});

const mapDispatchToProps = {
  getCredentials: getTestCredentials.actions.send,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/VirtualVideoTest/enhance.js